export const MAPPING_ICON_SWEEP_MS = 720;

const MAPPING_ICON_RADIUS = 7;
const MAPPING_ICON_CIRCUMFERENCE = 2 * Math.PI * MAPPING_ICON_RADIUS;

interface MappingIconProps {
  className?: string;
  dotVisible?: boolean;
  ringOpacity?: number;
  ringTransition?: string;
  sweepProgress?: number;
}

export default function MappingIcon({
  className = 'h-5 w-5',
  dotVisible = true,
  ringOpacity = 1,
  ringTransition,
  sweepProgress = 1,
}: MappingIconProps) {
  return (
    <span
      className={`relative flex items-center justify-center ${className}`}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 20 20"
        className="absolute inset-0 h-full w-full"
        focusable="false"
      >
        <circle
          cx="10"
          cy="10"
          r={MAPPING_ICON_RADIUS}
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray={`${MAPPING_ICON_CIRCUMFERENCE} ${MAPPING_ICON_CIRCUMFERENCE}`}
          strokeDashoffset={MAPPING_ICON_CIRCUMFERENCE * (1 - sweepProgress)}
          style={{
            transform: 'rotate(-90deg)',
            transformOrigin: '50% 50%',
            opacity: ringOpacity,
            transition: ringTransition,
          }}
        />
      </svg>
      <span
        className={`absolute h-[27%] w-[27%] rounded-full bg-current transition-all duration-200 ease-out ${dotVisible ? 'scale-100 opacity-100' : 'scale-50 opacity-0'}`}
      />
    </span>
  );
}
